/** Default landing route after tenant switch (provider-agnostic). */
export const HOME_PATH = 'dashboard';
